import Vue from 'vue';
import { Button, Input, Checkbox, Form, FormItem, Message, Select, Option, Step, Steps, Autocomplete, Radio, RadioGroup, Loading } from 'element-ui';

Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Autocomplete);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Loading);
Vue.prototype.$message = Message;
